function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("title", null, "\n    fullscreen-expand\n  ");

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M20,21.38A1.37,1.37,0,0,1,19,21L2.08,4A1.38,1.38,0,0,1,4,2.08L21,19a1.38,1.38,0,0,1-1,2.35Z",
  fill: "#231f20"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M3,12.32a1.29,1.29,0,0,1-.63-.17,1.26,1.26,0,0,1-.47-1.73c1.84-3.22.05-6.74,0-6.78A1.27,1.27,0,0,1,4.17,2.46c.11.19,2.47,4.77-.07,9.22A1.27,1.27,0,0,1,3,12.32Z",
  fill: "#231f20"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M7.19,5.27a10.92,10.92,0,0,1-4.73-1.1A1.27,1.27,0,0,1,3.64,1.93s3.57,1.8,6.78,0a1.27,1.27,0,1,1,1.26,2.2A9,9,0,0,1,7.19,5.27Z",
  fill: "#231f20"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "M37,38.32a1.37,1.37,0,0,1-1-.4L19,21A1.37,1.37,0,0,1,21,19L37.92,36a1.39,1.39,0,0,1,0,2A1.36,1.36,0,0,1,37,38.32Z",
  fill: "#231f20"
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  d: "M29,38.38a1.38,1.38,0,0,1-.68-2.57c4.5-2.57,9.12-.18,9.32-.08a1.37,1.37,0,0,1,.57,1.86,1.36,1.36,0,0,1-1.85.57c-.07,0-3.52-1.76-6.68,0A1.38,1.38,0,0,1,29,38.38Z",
  fill: "#231f20"
});

var _ref7 = /*#__PURE__*/React.createElement("path", {
  d: "M37,38.32a1.39,1.39,0,0,1-1.22-.73c-.1-.2-2.49-4.82.08-9.32a1.37,1.37,0,0,1,2.39,1.36,7.5,7.5,0,0,0,0,6.67,1.37,1.37,0,0,1-1.21,2Z",
  fill: "#231f20"
});

var _ref8 = /*#__PURE__*/React.createElement("path", {
  d: "M3.05,38.32a1.36,1.36,0,0,1-1-.4,1.39,1.39,0,0,1,0-2L19,19A1.37,1.37,0,0,1,21,21L4,37.92A1.37,1.37,0,0,1,3.05,38.32Z",
  fill: "#231f20"
});

var _ref9 = /*#__PURE__*/React.createElement("path", {
  d: "M11.05,38.38a1.38,1.38,0,0,1-.68-.18,7.5,7.5,0,0,0-6.67,0,1.38,1.38,0,0,1-1.29-2.43c.2-.1,4.82-2.49,9.32.08a1.38,1.38,0,0,1-.68,2.57Z",
  fill: "#231f20"
});

var _ref10 = /*#__PURE__*/React.createElement("path", {
  d: "M3.05,38.21a1.27,1.27,0,0,1-1.12-1.85s1.8-3.57,0-6.78a1.27,1.27,0,0,1,2.2-1.26c2.54,4.45.17,9,.07,9.22A1.25,1.25,0,0,1,3.05,38.21Z",
  fill: "#231f20"
});

var _ref11 = /*#__PURE__*/React.createElement("path", {
  d: "M20,21.38A1.38,1.38,0,0,1,19,19L36,2.08a1.38,1.38,0,1,1,2,2L21,21A1.37,1.37,0,0,1,20,21.38Z",
  fill: "#231f20"
});

var _ref12 = /*#__PURE__*/React.createElement("path", {
  d: "M37,12.42a1.38,1.38,0,0,1-1.19-.69c-2.57-4.5-.18-9.12-.08-9.32a1.37,1.37,0,0,1,1.86-.57,1.36,1.36,0,0,1,.57,1.85c0,.07-1.76,3.52,0,6.68a1.37,1.37,0,0,1-.52,1.87A1.29,1.29,0,0,1,37,12.42Z",
  fill: "#231f20"
});

var _ref13 = /*#__PURE__*/React.createElement("path", {
  d: "M32.81,5.27A9,9,0,0,1,28.32,4.1a1.27,1.27,0,1,1,1.26-2.2c3.22,1.84,6.74.05,6.78,0a1.27,1.27,0,0,1,1.18,2.24A10.92,10.92,0,0,1,32.81,5.27Z",
  fill: "#231f20"
});

function SvgFullscreenExpand(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    "data-name": "Layer 1",
    viewBox: "0 0 40 40"
  }, props), _ref, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12, _ref13);
}

export default SvgFullscreenExpand;